import { useCallback } from 'react'
import { BestContactMethodOptionsType } from './useData'
import { useFormikContext } from 'formik'
import { IAddOpportunityFormModel } from '@user/components/Opportunities/AddOpportunityPage/typings'
import { ILeadFormModel } from '@user/components/Leads/AddLeadForm/typings'

export function useHandlers({ name }) {
  const { setFieldValue } = useFormikContext<
    ILeadFormModel | IAddOpportunityFormModel
  >()

  const handelChange = useCallback(
    (value: BestContactMethodOptionsType | null) => {
      setFieldValue(name, value?.value)
    },
    [],
  )

  return {
    handelChange,
  }
}
